import React from "react";

/*****************************************************************************
 * REVISION 1.0
 * Fecha: 25/12/2022
 *
 * @description componente template para manejo footers
 * @author luis.ferrer
 * @version 1.0
 *
 ****************************************************************************/
const Footer = ({ footerType }) => {
  return <>{footerType === "login" ? <LoginFooter /> : <BoardFooter />}</>;
};

const LoginFooter = () => (
  <footer className="w-100 brg-footer text-center">
    <div className="col-12">
      <ul className="redes-pv m-0 p-0">
        <li>
          <a
            href="https://www.facebook.com/ParvalRD/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-facebook"></i>
          </a>
        </li>
        <li>
          <a
            href="https://www.instagram.com/parvalrd/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-instagram"></i>
          </a>
        </li>
        <li>
          <a
            href="https://www.linkedin.com/company/parval-puesto-de-bolsa/"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-linkedin"></i>
          </a>
        </li>
        <li>
          <a
            href="https://twitter.com/parval_rd"
            target="_blank"
            rel="noreferrer"
          >
            <i className="fa-brands fa-twitter"></i>
          </a>
        </li>
      </ul>
      <p>
        <a href="mailto:info@parval.com.do">info@parval.com.do</a>
      </p>
      <p>809-560-0909 | 809-472-7825</p>
      <p className="mb-3">Copyright 2023. Todos los derechos reservados.</p>
    </div>
  </footer>
);

const BoardFooter = () => (
  <footer className="footer-board p-2">
    <div className="container-fluid">
      <div className="row text-muted">
        <div className="col-6 text-start">
          <p className="mb-0">
            <span className="text-muted">
              Copyright 2023. Todos los derechos reservados.
            </span>
          </p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
